export default __webpack_public_path__ + "static/Vietnam-0e3d827ffc5df17d7736fdab1976a3d0.png";